import { render, staticRenderFns } from "./AddPayment.vue?vue&type=template&id=47a53ce0&scoped=true&"
import script from "./AddPayment.vue?vue&type=script&lang=js&"
export * from "./AddPayment.vue?vue&type=script&lang=js&"
import style0 from "./AddPayment.vue?vue&type=style&index=0&id=47a53ce0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47a53ce0",
  null
  
)

export default component.exports